export default "/h5/static/images/empty-data.png"